<template>
  <cropper
    v-if="imageUrl"
    ref="cropper"
    class="cropper"
    :src="imageUrl"
    :stencil-size="{
      width: minImageWidth * scaleToPreview,
      height: minImageHeight * scaleToPreview
    }"
    :stencil-props="{
      handlers: {},
      movable: false,
      resizable: false,
      aspectRatio: minImageWidth / minImageHeight
    }"
    :min-width="minImageWidth"
    :min-height="minImageHeight"
    image-restriction="stencil"
    @ready="onCropperReady"
  />
</template>

<script lang="ts">
import Vue from "vue";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default Vue.extend({
  name: "ImageCropper",

  components: {
    Cropper
  },

  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    minImageWidth: {
      type: Number,
      required: true
    },
    minImageHeight: {
      type: Number,
      required: true
    },
    scaleToPreview: {
      type: Number,
      required: true
    }
  },

  methods: {
    // cropperの準備完了時に呼ばれる（画像を初期フィット状態にリセット）
    onCropperReady() {
      // cropperをリセットして、画像をステンシルにぴったり収める
      this.$nextTick(() => {
        const cropper = this.$refs.cropper as any;
        if (cropper && cropper.reset) {
          cropper.reset();
        }
      });
    },
    reset() {
      const cropper = this.$refs.cropper as any;
      if (cropper && cropper.reset) {
        cropper.reset();
      }
    },
    async getCroppedBlob(mimeType: string): Promise<Blob> {
      const cropper = this.$refs.cropper as any;
      if (!cropper || !cropper.getResult) {
        throw new Error("Cropperが初期化されていません。");
      }

      // クロップされた領域のcanvasを取得
      const result = cropper.getResult();
      const canvas = result.canvas;
      if (!canvas) {
        throw new Error("クロップ画像の取得に失敗しました。");
      }

      // canvasをBlobに変換（元の形式を保持、品質90%にする。100%にすると元画像より容量が大きくなる）
      const croppedBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(
          (blob: Blob | null) => {
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error("Blob変換に失敗しました。"));
            }
          },
          mimeType,
          0.9
        );
      });

      return croppedBlob;
    }
  }
});
</script>

<style scoped>
.cropper {
  width: 100%;
  height: 100%;
}

/* cropperの背景色とforegroundを透明に */
.cropper >>> .vue-advanced-cropper__background {
  background: transparent !important;
}

.cropper >>> .vue-advanced-cropper__foreground {
  background: transparent !important;
}
</style>
